import { useFragment } from "@apollo/client/react";
import {
  MobileServicePermissionsFragment,
  MobileServicePermissionsFragmentDoc,
  PermanentServicePermissionsFragment,
  PermanentServicePermissionsFragmentDoc,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook to retrieve a service's permissions data from the cache.
 *
 * This hook uses the `useFragment` hook from Apollo Client to automatically
 * subscribe to changes in the [Permanent][Mobile]Service data.
 *
 * @param {{string}} {id} - The BidDecision from which to retrieve the data.
 * @returns {PermanentServicePermissionsFragment | MobileServicePermissionsFragment | undefined} - The Service permissions data or undefined if not available.
 *
 * @example
 * const servicePermissionsData = useServicePermissionsData("1", "Permanent");
 *
 */
export const useServicePermissionsData = ({ serviceID, type }: { serviceID: string, type: "Permanent" | "Mobile" }): PermanentServicePermissionsFragment | MobileServicePermissionsFragment | undefined => {
  const { data } = useFragment({
    fragment: type === "Permanent" ? PermanentServicePermissionsFragmentDoc : MobileServicePermissionsFragmentDoc,
    from: {
      __typename: `${type}Service`,
      _id: serviceID,
    }
  });

  return data as PermanentServicePermissionsFragment | MobileServicePermissionsFragment | undefined;
};
